import React from 'react';
import { Link } from 'react-router-dom';

import SEO from '../../constants/seo';
import Page from '../../components/Page';
import config from '../../config';
import RegionIntro from './RegionIntro';

const { ASSETS_URL } = config;

const explorePage = [
  {
    title: 'Everything about the Everest Base Camp Trek',
    link: 'p/everything-about-the-everest-base-camp-trek/',
    image: `${ASSETS_URL}/every-thing-about-the-everest-base-camp-trek.jpg`,
    subtext: 'Comprehensive. Accurate. Up to Date.',
    region: {
      TREKS: <Link to="/treks">9</Link>,
      PLACES: <Link to="/places?region=everest">80</Link>,
      'MAX ALT.': '5,643m',
    },
  },
  {
    title: 'Everything about Annapurna Base Camp Trek Region',
    link: 'p/everything-about-the-annapurna-base-camp-trek/',
    image: `${ASSETS_URL}/annapurna_base_camp_region.jpg`,
    subtext: 'Comprehensive.Accurate.Up to Date.',
    region: {
      TREKS: <Link to="/treks">5</Link>,
      PLACES: <Link to="/places?region=annapurna">85</Link>,
      'MAX ALT.': '4,120m',
    },
  },
  {
    title: 'Everything about the Annapurna Circuit Trek',
    link: 'p/everything-about-the-annapurna-circuit-trek/',
    image: `${ASSETS_URL}/annapurna.jpg`,
    subtext: 'Comprehensive.Accurate.Up to Date.',
    region: {
      TREKS: <Link to="/treks">3</Link>,
      PLACES: <Link to="/places?region=annapurna">111</Link>,
      'MAX ALT.': '5,416m',
    },
  },
  {
    title: 'Trekking in Nepal- A Checklist :)',
    link: 'p/trekking-in-nepal-checklist/',
    image: `${ASSETS_URL}/trekking-in-nepal-a-checklist2.jpg`,
    subtext: 'Know everything in under 10 min.',
    region: {
      ITEMS: '89',
      GEARS: '51',
      MEDICINE: '22',
    },
  },
  {
    title: 'Health And Safety While Trekking in Nepal',
    link: 'p/health-and-safety-while-trekking-in-nepal/',
    image: `${ASSETS_URL}/health-and-safety-while-trekking-in-nepal.jpg`,
    subtext: 'Water Safety.Altitude Illness.Rescue Contacts. This has it all.',
    region: {
      TIPS: '83',
      HAZARDS: '34',
      CONTACTS: '289',
    },
  },
  {
    title: 'The Hippest Intro to Nepal',
    link: 'p/intro-to-nepal/',
    image: `${ASSETS_URL}/nepal.jpg`,
    subtext: 'Find why Nepal is the way it is and Nepalese are the way they are.',
    region: {
      INSIGHTS: '49',
      SIGHTS: '10',
      SMILES: '89',
    },
  },
];

const Explore = () => (
  <Page {...SEO.explore}>
    <div className="container">
      {explorePage.map(item => (
        <RegionIntro
          key={item.title}
          title={item.title}
          link={item.link}
          image={item.image}
          subtext={item.subtext}
          region={item.region}
        />
      ))}
    </div>
  </Page>
);

export default Explore;



// WEBPACK FOOTER //
// ./src/screens/Explore/index.jsx